import { EyeIcon } from "lucide-react"

import type { CommonDocument } from "@/components/documents/context/DocumentsProvider"
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog"
import { cn } from "@/lib/utils"

interface Props {
  className: string
  doc: CommonDocument
}

export function PreviewDialog({ className, doc }: Props) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button title="Preview document" disabled={!doc.previewUrl}>
          <EyeIcon
            className={cn(
              "inline-block",
              doc.previewUrl
                ? "text-primary cursor-pointer"
                : "text-muted/20 cursor-not-allowed",
              className,
            )}
          />
        </button>
      </DialogTrigger>
      <DialogContent className="p-10">
        <img
          className="h-auto max-h-[70vh] max-w-full object-contain"
          src={doc.previewUrl}
          alt={doc.isConfirmed ? doc.typeName || "" : doc.filename}
        />
      </DialogContent>
    </Dialog>
  )
}
